module.exports = __webpack_public_path__ + "img/building-wall-panels-3.b219ba2c.jpeg";